import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Dasboard from "../dasboard/dashboard";
import clienteAxios from "../../axios";


export default function HtmlEditor({ onSave }) {
  const [content, setContent] = useState(`  
 
  <div class="preheader">
    ¡Gracias por tu opinión, Aquí tienes tu premio: {{premio}}. Código: {{codigo}}. Válido hasta {{vigencia}}.
  </div>
  <table role="presentation" cellpadding="0" cellspacing="0" width="100%" style="background:#f4f6f8;">
    <tr>
      <td align="center" style="padding:24px;">
        <table role="presentation" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px;background:#ffffff;border-radius:12px;overflow:hidden;border:1px solid #e6e8eb;">          
          <tr>
            <td align="center" style="padding:28px 24px;background:#000;">
             
              <img src="https://parquemonchis.com/logo.jpg" width="240"  alt="Logo" style="display:block;border:0;outline:none;text-decoration:none;">
              <h1 style="margin:16px 0 0 0;font-family:Arial,Helvetica,sans-serif;font-size:22px;line-height:28px;color:#ffffff;">
                ¡Gracias por tu opinión!
              </h1>
            </td>
          </tr>         
          <tr>
            <td style="padding:24px 24px 8px 24px;font-family:Arial,Helvetica,sans-serif;color:#0f172a;">              
              <p style="margin:0 0 16px 0;font-size:16px;line-height:24px;">
                ¡Tu participación en nuestra <strong>encuesta de satisfacción</strong> nos ayuda a mejorar! Como agradecimiento, eres ganador(a) de:
              </p>
              <div style="margin:16px 0;padding:16px;border:1px dashed #cbd5e1;border-radius:10px;background:#f8fafc;">
                <p style="margin:0 0 8px 0;font-size:18px;line-height:24px;font-weight:bold;">
                  🎁 {{premio}}
                </p>
                <p style="margin:0;font-size:14px;line-height:21px;color:#334155;">
                  Código: <strong style="font-family:monospace">{{codigo}}</strong><br>
                  Vigencia: <strong>{{vigencia}}</strong>
                </p>
              </div>
              <p style="margin:0 0 20px 0;font-size:16px;line-height:24px;">
                Para canjearlo, muestra este correo en sucursal o utiliza el botón siguiente y sigue las instrucciones.
              </p>               
              <table role="presentation" cellspacing="0" cellpadding="0">
                <tr>
                  <td align="center" bgcolor="#2563eb" style="border-radius:8px;">
                    <a href="{{url_canje}}" target="_blank"
                       style="display:inline-block;padding:12px 22px;font-family:Arial,Helvetica,sans-serif;font-size:16px;line-height:20px;color:#ffffff;">
                      Canjear mi premio
                    </a>
                  </td>
                </tr>
              </table>
              <p style="margin:16px 0 0 0;font-size:14px;line-height:21px;color:#475569;">
                También puedes canjearlo con el QR:
              </p>
              <p style="margin:8px 0 0 0;">
                <img src="{{qr_canje_src}}" alt="QR de canje" width="128" height="128" style="display:block;border:0;">
              </p>
            </td>
          </tr>          
          <tr>
            <td style="padding:8px 24px 24px 24px;font-family:Arial,Helvetica,sans-serif;color:#0f172a;">
              <h3 style="margin:0 0 8px 0;font-size:16px;line-height:22px;">Condiciones</h3>
              <ul style="padding-left:18px;margin:0 0 12px 0;color:#334155;font-size:14px;line-height:20px;">
                <li>Válido para el titular de este correo.</li>
                <li>Un premio por cuenta/cliente. No acumulable con otras promociones.</li>
                <li>Sujeto a disponibilidad y a cambios sin previo aviso.</li>
                <li>Debes presentar una identificación si se solicita.</li>               
              </ul>                            
            </td>
          </tr>                     
        </table>              
      </td>
    </tr>
  </table> 
`

  );

  const handleSave = () => {
    if (onSave) {
      onSave(content); // devuelve el HTML al padre
    }
  };

    const consultarPremios = async () => {    
    const config = {
      "Content-Type": "application/json",    
    }
    const data = {
      "sp": "premios",
      "op": "listar",
    }
    try {
      const result = await clienteAxios.post("/api/sp", data, config);
       setContent(result.data.data[0]);
    } catch (error) {
      console.error("Error al consultar premios:", error);
    }
  };

  return (
    <>
      <Dasboard />

      <main className="-mt-32 ">
        <div className="mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8 ">
          <div className="rounded-lg bg-white px-5 py-6 shadow sm:px-6 max-w-full   relative  space-y-3 min-h-screen overflow-auto p-4">
            <h2 className="text-xl font-bold">✍️ Editor HTML</h2>

            <ReactQuill
              theme="snow"
              value={content}
              onChange={setContent}
              placeholder="Escribe aquí tu contenido..."
              className="bg-white rounded-lg"
              modules={{
                toolbar: [
                  [{ header: [1, 2, 3, false] }],       // Títulos
                  ["bold", "italic", "underline", "strike"], // Formato de texto
                  [{ list: "ordered" }, { list: "bullet" }], // Listas                    
                  [{ indent: "-1" }, { indent: "+1" }],      // Sangría
                  [{ align: [] }],                            // Alineación
                  [{ color: [] }, { background: [] }],       // Color de texto y fondo
                  ["link", "image", "video"],                // Insertar links, imágenes y videos
                  ["clean"],                                 // Limpiar formato
                ],
              }}
            />

            <button
              onClick={handleSave}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
            >
              Guardar
            </button>

            <div className="border-t pt-4">
              <h3 className="font-semibold">🔎 Vista previa:</h3>
              <div
                className="p-3 border rounded bg-gray-50"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            </div>
          </div>

        </div>
      </main>
    </>
  );
}
